import { FC, FormEvent, useState } from 'react'
import { GuessType, RoundType } from '../../types'
import { StyledRoundView } from '.'

type Props = {
  guess?: GuessType
  round: RoundType
  submitGuess: (amount: number) => Promise<void>
  nextRound: () => Promise<void>
}

const RoundView: FC<Props> = ({ guess, round, submitGuess, nextRound }) => {
  const [guessAmount, setGuessAmount] = useState<number>()

  const handleSubmit = async (e?: FormEvent) => {
    e?.preventDefault()

    if (!guessAmount || !!guess) {
      return
    }

    await submitGuess(guessAmount)
    setGuessAmount(0)
  }

  const generateTourUrl = () => {
    if (round.tour.includes('youriguide')) {
      return `${round.tour}?page=video&unbranded=1&nomap=1&nodetails=1&nocontrols=1&minfp=1&autostart=1&nox=1&bgcolor=FFFFFF`
    }
    return round.tour
  }

  return (
    <StyledRoundView>
      {!!guess && (
        <div className="guess-modal-container">
          <div className="guess-modal">
            <span className="guess-text">You guessed <b>${guess.guess}</b>, which was <b>${Math.abs(guess.real - guess.guess)}</b> away from the real home value (<b>${guess.real}</b>). You earned <b>{guess.score}</b> points!</span>
            <div className="guess-progress-bar">
              <progress value={guess.score} max="5000" />
            </div>
            <button onClick={() => nextRound()}>{round.index === 2 ? 'Finish Game' : 'Next Round'}</button>
          </div>
          <div className="guess-modal-backdrop"/>
        </div>
      )}
      <form className="guess-box" onSubmit={(e) => handleSubmit(e)}>
        <div className="input-container">
          <span className="dollar-symbol">${round.currency}</span>
          <input autoFocus placeholder="House Sale Price" value={guessAmount} type="number" required onChange={(e) => setGuessAmount(parseInt(e.target.value))}/>
        </div>
        <button disabled={!guessAmount || !!guess}>Guess</button>
      </form>
      <iframe
        title="game"
        src={generateTourUrl()}
      />
    </StyledRoundView>
  )
}

export default RoundView
